import axios from 'axios';

const baseUrl = window.REACT_APP_ALERTS_API_URL;

export const updateAlert = async (id, alert, region, token) => {
    return axios.put(`${baseUrl}/${id}`, alert, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        params: {
            region: region,
        }
    })
}

export const updateAlertActive = async (id, alert, region, token) => {
    return axios.put(`${baseUrl}/PutAlertActiveStatus`, alert, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        params: {
            id: id,
            region: region
        }
    })
}


export const createAlert = async (alert, region, token) => {
    return axios.post(`${baseUrl}`, alert, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        params: {
            region: region
        }
    })
}

export const getAlertsForEntity = async (id, region, token) => {
    const fetchStr = `${baseUrl}/GetAlertsForEntity?EntityId=${id}&region=${region}`;
    return axios.get(fetchStr,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                EntityId: id,
                region: region
            }
        });
}

export const deleteAlert = async (id, region, token) => {
    return axios.delete(`${baseUrl}/${id}?region=${region}`, {
        method: 'DELETE',
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}